import { ConciergeBlockStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import MessageAiIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface ConciergeBlockNodeData {
  deleteElements: (id: string) => void;
  step: PartialWithRequiredType<ConciergeBlockStep>;
}

export function ConciergeBlockNode(data: {
  id: string;
  data: ConciergeBlockNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();
  const { prompt } = data.data.step;

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        disabled={data.data.step.disabled}
        icon={
          <RedoFeaturedIcon color="success" Icon={MessageAiIcon} size="xs" />
        }
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title="Concierge"
      >
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text fontSize="xxs">{t("Shopper AI prompt")}</Text>
          {prompt ? (
            <Text className={NodeCSS.clampedValueText}>{prompt}</Text>
          ) : (
            <Text className={NodeCSS.placeholderText}>
              {t("Needs configuration")}
            </Text>
          )}
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
